import { OfferedServiceResourceBase } from "../json-schemas/base/offered_service_resource"
import { AvailableAtResponse } from "../json-schemas/serializers/available-at-response"
import { OfferedServiceResourceListOnlyIdsResponse } from "../json-schemas/serializers/offered-service-resource-list-only-ids-response"
import { OfferedServiceResourceListResponse } from "../json-schemas/serializers/offered-service-resource-list-response"
import { httpGet, httpGetRoute, httpPost } from "../utils/http.service"
import { I18nService } from "../utils/i18n.service"
import { RansackQuery as EmployeeRansackQuery } from "./employees.service"

const i18nScoped = new I18nService(require('./offered-service-resources.service.yml'))

export type OfferedServiceResourceWorkingDaysReference = OfferedServiceResourceBase['working_days_reference'] 

export interface RansackQuery {
  'q[find_by_offered_service]'?: number
  'q[find_by_selected_combination_attributes]'?: { allowed_offered_service_attr_id: number, value: string }[]
  'q[find_by_service_delivery_location]'?: number
  'q[intervention_sector]'?: string
  'q[id_not_in][]'?: number[]
  'q[id_in][]'?: number[]
  'q[deactivated_eq]'?: boolean
  'q[s]'?: 'event_count_last_30_days desc' | 'event_count_next_30_days desc'
  'available_for'?: EmployeeRansackQuery['available_for']
}

export function offeredServiceResourcesList (query: RansackQuery): Promise<OfferedServiceResourceListResponse>
export function offeredServiceResourcesList (query: RansackQuery, output: 'only_ids'): Promise<OfferedServiceResourceListOnlyIdsResponse>
export function offeredServiceResourcesList (query: RansackQuery = {}, output?: 'only_ids'): Promise<OfferedServiceResourceListResponse | OfferedServiceResourceListOnlyIdsResponse> {
  return httpGet(`/${httpGetRoute()}/offered_service_resources`, { ...query, output })
}

export function offeredServiceResourceIsAvailable (id: number, body: RansackQuery['available_for']): Promise<AvailableAtResponse> {
  return httpPost(`/${httpGetRoute()}/offered_service_resources/${id}/available_at`, body)
}

export function offeredServiceResourceShowPath (id: number) {
  return `/${httpGetRoute()}/offered_service_resources/${id}`
}

export function offeredServiceResourceI18nWorkingDaysReference (workingDayReference: OfferedServiceResourceWorkingDaysReference): string {
  return i18nScoped.t('working_days_reference.' + workingDayReference)
}
